import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./Select";

/** Saved-spot picker shown in LogCatch. Spots are scoped to the lake of the active session. */
export function SpotPicker({
  spots,
  value,
  onChange,
}: {
  spots: any[];
  value: string; // spot id as string, "" = no spot
  onChange: (spotId: string, spot: any | null) => void;
}) {
  if (!spots || spots.length === 0) return null;

  return (
    <div>
      <label
        htmlFor="catch-spot-picker"
        className="mb-1 block text-sm font-medium text-primary"
      >
        Saved spot
      </label>
      <Select
        value={value}
        onValueChange={(id) => {
          if (id === "__none__") {
            onChange("", null);
          } else {
            const spot = spots.find((s) => String(s.id) === id) ?? null;
            onChange(id, spot);
          }
        }}
      >
        <SelectTrigger id="catch-spot-picker">
          <SelectValue placeholder="No saved spot" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="__none__">No saved spot</SelectItem>
          {spots.map((s) => (
            <SelectItem key={s.id} value={String(s.id)}>
              {s.name}
              {s.distance_m != null ? ` · ${s.distance_m}m` : ""}
              {s.depth_ft != null ? ` · ${s.depth_ft}ft` : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="mt-1 text-xs text-secondary">
        Optional — selecting a spot prefills details below. Every value stays
        editable.
      </p>
    </div>
  );
}
